import { pageNames } from 'src/pageNames'

export type PagesType = {
    name: string
    labelKey: string
}[]

const pages: PagesType = [
    {
        name: pageNames.index,
        labelKey: 'pages.home'
    },
    {
        name: pageNames.services,
        labelKey: 'pages.services'
    },
    {
        name: pageNames.references,
        labelKey: 'pages.references'
    },
    {
        name: pageNames.team,
        labelKey: 'pages.team'
    },
    {
        name: pageNames.career,
        labelKey: 'pages.career'
    },
    {
        name: pageNames.contact,
        labelKey: 'pages.contact'
    }
]
export default pages

export const isHomePage = (path: string): boolean =>
    ['/', '/de/', '/en/'].includes(path)

export const isReferencesPage = (path: string): boolean =>
    ['/references/', '/de/references/', '/sk/references/'].includes(path)

export const isContactPage = (path: string): boolean =>
    ['/contact/', '/de/contact/', '/sk/contact/'].includes(path)
